import { Component, Input, OnInit } from '@angular/core';
import { ServiceTypeEnum } from '../../models/cartDetails/service-type.enum';
import { MonthForm } from '../../utils/pipes/monthForm';
import { RechargingDeclination } from '../../utils/pipes/rechargingDeclination';
import { PromotionTypeEnum } from '../../models/cartDetails/promotionType.model';

@Component({
  selector: '[slot-contract-length]',
  templateUrl: './slot-contract-length.component.html'
})
export class SlotContractLengthComponent implements OnInit {

  @Input() promotionType: PromotionTypeEnum;
  @Input() serviceType: ServiceTypeEnum;
  @Input() termOfServiceNumber: number;
  @Input() deviceTermLength: number;
  @Input() hasDevice: boolean;

  public contractDuration: string;
  public deviceInstallment: string;
  private monthFormDeclination: MonthForm;
  private rechargingDeclination: RechargingDeclination;

  protected readonly ServiceTypeEnum = ServiceTypeEnum;

  constructor(
  ) {
    this.monthFormDeclination = new MonthForm();
    this.rechargingDeclination = new RechargingDeclination();
  }

  ngOnInit(): void {
    this.contractDuration = this.getContractDurationText();

    if (this.hasDevice) {
      this.deviceInstallment = this.getDeviceInstallmentText();
    }
  }

  public get isInstallmentFlex(): boolean {
    return this.promotionType === PromotionTypeEnum.INSTALLMENT_FLEX;
  }

  private get isTermsUnlimited(): boolean {
    return this.serviceType === ServiceTypeEnum.POSTPAID && this.termOfServiceNumber === -1;
  }

  private get isTermOffer(): boolean {
    return this.serviceType === ServiceTypeEnum.POSTPAID && this.termOfServiceNumber !== -1;
  }

  private get isRecharges(): boolean {
    return this.serviceType === ServiceTypeEnum.MIX && this.termOfServiceNumber !== -1;
  }

  private getContractDurationText(): string {
    if (this.isTermsUnlimited) {
      // "Umowa na czas nieokreślony"
      return 'czas nieokreślony';
    } else if (this.isTermOffer) {
      // "Umowa na 24 miesiące"
      return `${this.termOfServiceNumber} ${this.monthFormDeclination.transform(this.termOfServiceNumber)}`;
    } else if (this.isRecharges) {
      // "Umowa na 24 doładowania"
      return `${this.termOfServiceNumber} ${this.rechargingDeclination.transform(this.termOfServiceNumber)}`;
    }
  }

  private getDeviceInstallmentText(): string {
    const duration: number = this.deviceTermLength ? this.deviceTermLength : this.termOfServiceNumber;

    return `${duration} ${this.monthFormDeclination.transform(duration)}`;
  }

}

